import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Carousel } from 'react-bootstrap';

import GraphicIframe from './GraphicIframe';
import MapIframe from './MapIframe';
import TableIframe from './TableIframe';

import { StyledCarousel } from './styles';

const VERTICAL_HEIGHT = 100;

const CarouselFive = ({
  firstCarouselItem,
  secondCarouselItem,
  thirdCarouselItem,
  fourthCarouselItem,
  fifthCarouselItem,
  isPreview,
  isPublic
}) => {
  const [index, setIndex] = useState(0);
  const handleSelect = selectedIndex => setIndex(selectedIndex);

  return (
    <StyledCarousel interval={null} activeIndex={index} onSelect={handleSelect}>
      <Carousel.Item>
        <div style={{ height: `calc(95vh - ${isPublic ? 0 : VERTICAL_HEIGHT}px)` }}>
          {React.cloneElement(firstCarouselItem, { isCarousel: true, isPreview })}
        </div>
      </Carousel.Item>
      <Carousel.Item>
        <div style={{ height: `calc(95vh - ${isPublic ? 0 : VERTICAL_HEIGHT}px)` }}>
          {React.cloneElement(secondCarouselItem, { isCarousel: true, isPreview })}
        </div>
      </Carousel.Item>
      <Carousel.Item>
        <div style={{ height: `calc(95vh - ${isPublic ? 0 : VERTICAL_HEIGHT}px)` }}>
          {React.cloneElement(thirdCarouselItem, { isCarousel: true, isPreview })}
        </div>
      </Carousel.Item>
      <Carousel.Item>
        <div style={{ height: `calc(95vh - ${isPublic ? 0 : VERTICAL_HEIGHT}px)` }}>
          {React.cloneElement(fourthCarouselItem, { isCarousel: true, isPreview })}
        </div>
      </Carousel.Item>
      <Carousel.Item>
        <div style={{ height: `calc(95vh - ${isPublic ? 0 : VERTICAL_HEIGHT}px)` }}>
          {React.cloneElement(fifthCarouselItem, { isCarousel: true, isPreview })}
        </div>
      </Carousel.Item>
    </StyledCarousel>
  );
};
CarouselFive.defaultProps = {
  firstCarouselItem: <MapIframe />,
  secondCarouselItem: <GraphicIframe />,
  thirdCarouselItem: <TableIframe />,
  fourthCarouselItem: <TableIframe />,
  fifthCarouselItem: <TableIframe />,
  isPreview: false,
  isPublic: false
};

CarouselFive.propTypes = {
  firstCarouselItem: PropTypes.node,
  secondCarouselItem: PropTypes.node,
  thirdCarouselItem: PropTypes.node,
  fourthCarouselItem: PropTypes.node,
  fifthCarouselItem: PropTypes.node,
  isPreview: PropTypes.bool,
  isPublic: PropTypes.bool
};

export default CarouselFive;
